/**
 * AI assist API client. Thin wrappers over the shared `apiFetch` helper
 * (see ./api) that map to the Elysia /ai module. The API key is server-side
 * only and never touches this layer.
 */
import type { AiGenerateInput, AiGenerateResult, AiGenerationSummary, AiStatus } from '@fc/core'
import { apiFetch } from './api'

export type {
  AiGenerateInput,
  AiGenerateResult,
  AiGenerationSummary,
  AiStatus,
  AiKind,
} from '@fc/core'

export const getAiStatus = () => apiFetch<AiStatus>('/ai/status')

export const generateDraft = (input: AiGenerateInput) =>
  apiFetch<AiGenerateResult>('/ai/generate', {
    method: 'POST',
    body: JSON.stringify(input),
  })

export const listAiHistory = () => apiFetch<AiGenerationSummary[]>('/ai/history')
